import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                      Получить количество упоминаний сигнала
//------------------------------------------------------------------------------
export const getSignalMentionsCount = async (signalId) => {
  const url = `${backendUrl}/api/signals/mentions-count/?signal_id=${signalId}`;
  
  const options = {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
    },
  };
  
  try {
    const response = await fetchWithAuth(url, options);
    
    if (!response.ok) {
      throw new Error(`Ошибка при получении количества упоминаний: HTTP error! Status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения количества упоминаний сигнала:', error);
    throw error;
  }
};